import { styled } from '@mui/material';
import { colors } from '../../styles';

export const NavigationItem = styled('span')<{ isActive: boolean; activeColor: string }>`
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  color: ${(props) => props.color};

  a {
    padding: 8px;
    display: block;
    border-radius: 8px;
    background: ${({ isActive, activeColor }) => (isActive ? activeColor : 'transparent')};
    line-height: 1.25;
  }

  &:hover {
    color: ${colors.blue};
  }
`;
